/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseBlogGridFragment} from '@amblique/contentful/app/contentful/fragments/blog-grid/base-blog-grid.fragment';
import {BlogFragment} from '@amblique/contentful/app/contentful/fragments/blog/blog.fragment';
import {LinkFragment} from '@amblique/contentful/app/contentful/fragments/link/link.fragment';

export const FullBlogGridFragment = gql`
  ${BaseBlogGridFragment}
  ${BlogFragment}
  ${LinkFragment}

  fragment FullBlogGridFragment on BlogGrid {
    ...BaseBlogGridFragment

    blogSummaryCollection {
      items {
        __typename
        ... on Blog {
          ...BlogFragment
        }
      }
    }
    cta {
      ...LinkFragment
    }
  }
`;
